function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC } from 'react';
import { Image, IImageProps } from '../Image';
import logoThankYouFillGradient from './LogoSber.assets/logoThankYouFillGradient.svg';
import logoThankYouOutlineWhite from './LogoSber.assets/logoThankYouOutlineWhite.svg';
import logoThankYouOutlineGreen from './LogoSber.assets/logoThankYouOutlineGreen.svg';
import logoThankYouFillGreen from './LogoSber.assets/logoThankYouFillGreen.svg';
import logoThankYouIconGreen from './LogoSber.assets/logoThankYouIconGreen.svg';
import logoThankYouIconGradient from './LogoSber.assets/logoThankYouIconGradient.svg';
const LogoThankYouSberKinds = {
  fillGradient: logoThankYouFillGradient,
  fillGreen: logoThankYouFillGreen,
  iconGradient: logoThankYouIconGradient,
  iconGreen: logoThankYouIconGreen,
  outlineGreen: logoThankYouOutlineGreen,
  outlineWhite: logoThankYouOutlineWhite
};
export const LogoThankYou = ({
  alt = 'Логотип Сбер Спасибо',
  kind = 'fillGradient',
  size = 'auto',
  sizeBy = 'width',
  ...props
}) => {
  const srcProp = LogoThankYouSberKinds[kind];
  if (!srcProp) return null;
  const _size = Number(size);
  return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    alt: alt,
    width: sizeBy === 'width' && _size ? _size : 'auto',
    height: sizeBy === 'height' && _size ? _size : 'auto',
    src: srcProp
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LogoThankYou.displayName = 'LogoThankYou';
}